import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

export default class UnassignedDealersGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dealers: (props.dealers || []).slice(),
      selectedIds: {},
      reassignTarget: null,
      perRowTarget: {},
      search: "",
      busy: false,
      message: ""
    };
  }

  toggleSelect = (id) => {
    var sel = { ...this.state.selectedIds };
    if (sel[id]) delete sel[id]; else sel[id] = true;
    this.setState({ selectedIds: sel });
  };

  toggleSelectAll = () => {
    var visible = this.getFiltered();
    var allIds = visible.map(d => d.id);
    var allSelected = allIds.every(id => this.state.selectedIds[id]);
    if (allSelected) {
      var sel = { ...this.state.selectedIds };
      allIds.forEach(id => { delete sel[id]; });
      this.setState({ selectedIds: sel });
    } else {
      var sel2 = { ...this.state.selectedIds };
      allIds.forEach(id => { sel2[id] = true; });
      this.setState({ selectedIds: sel2 });
    }
  };

  getFiltered = () => {
    var s = this.state.search.toLowerCase().trim();
    if (!s) return this.state.dealers;
    return this.state.dealers.filter(d =>
      (d.name || "").toLowerCase().indexOf(s) > -1 ||
      (d.email || "").toLowerCase().indexOf(s) > -1 ||
      (d.company || "").toLowerCase().indexOf(s) > -1 ||
      (d.fficZips || "").toString().toLowerCase().indexOf(s) > -1
    );
  };

  reassignBulk = async () => {
    var ids = Object.keys(this.state.selectedIds);
    if (ids.length === 0) { this.setState({ message: "Select at least one dealer." }); return; }
    if (!this.state.reassignTarget || !this.state.reassignTarget.email) {
      this.setState({ message: "Choose a sales rep to reassign to." }); return;
    }
    var newRep = this.state.reassignTarget.email;
    if (!confirm("Assign " + ids.length + " dealer(s) to " + newRep + "?")) return;
    await this.callReassign(ids, newRep);
  };

  reassignOne = async (dealerId) => {
    var target = this.state.perRowTarget[dealerId];
    if (!target || !target.email) { this.setState({ message: "Pick a sales rep on this row first." }); return; }
    await this.callReassign([dealerId], target.email);
  };

  callReassign = async (ids, newRep) => {
    this.setState({ busy: true, message: "" });
    try {
      var res = await fetch("/api/Admin/ReassignDealers", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dealerUserIds: ids, newSalesRepEmail: newRep })
      });
      var body = await res.json();
      if (!res.ok) throw new Error(body.message || "Reassign failed");
      var idSet = new Set(ids);
      var remaining = this.state.dealers.filter(d => !idSet.has(d.id));
      var sel = { ...this.state.selectedIds };
      ids.forEach(id => delete sel[id]);
      this.setState({
        dealers: remaining,
        selectedIds: sel,
        reassignTarget: null,
        busy: false,
        message: "Assigned " + body.updated + " dealer(s) to " + newRep + (body.errors ? " (" + body.errors + " errors)" : "")
      });
    } catch (e) {
      this.setState({ busy: false, message: "Error: " + e.message });
    }
  };

  render() {
    var visible = this.getFiltered();
    var selectedCount = Object.keys(this.state.selectedIds).length;
    var allSelected = visible.length > 0 && visible.every(d => this.state.selectedIds[d.id]);
    var options = this.props.salesRepOptions || [];

    if (this.state.dealers.length === 0) {
      return (
        <div className="admin-section">
          <p className="admin-empty">All dealers have a sales rep assigned. Nothing to do here.</p>
        </div>
      );
    }

    return (
      <div>
        <div className="quote-history-filters" style={{ alignItems: "flex-end" }}>
          <div className="quote-filter-item">
            <label>Search</label>
            <input
              type="text"
              value={this.state.search}
              onChange={(e) => this.setState({ search: e.target.value })}
              placeholder="Name, email, company, zip"
              style={{ minWidth: "240px" }}
            />
          </div>
          <div className="quote-filter-item" style={{ minWidth: "260px" }}>
            <label>Bulk reassign selected to</label>
            <DropDownList
              data={options}
              textField="name"
              dataItemKey="email"
              value={this.state.reassignTarget}
              onChange={(e) => this.setState({ reassignTarget: e.target.value })}
              defaultItem={{ email: "", name: "Choose a sales rep..." }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="quote-filter-item">
            <button
              className="ui-button ink"
              style={{ background: "#333", color: "#fff" }}
              disabled={selectedCount === 0 || !this.state.reassignTarget || this.state.busy}
              onClick={this.reassignBulk}
            >
              {this.state.busy ? "Working..." : "Apply Bulk Assignment"}
            </button>
          </div>
          <div className="quote-filter-item">
            <span>{selectedCount} selected</span>
          </div>
        </div>
        {this.state.message && (
          <div style={{ padding: "8px 12px", marginBottom: "12px", background: "#f4f4f4", border: "1px solid #ddd", borderRadius: "3px" }}>
            {this.state.message}
          </div>
        )}
        <table className="admin-table" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "40px" }}>
                <input type="checkbox" checked={allSelected} onChange={this.toggleSelectAll} />
              </th>
              <th>Name</th>
              <th>Email</th>
              <th>Company</th>
              <th>Industry</th>
              <th>Zip</th>
              <th>Acct #</th>
              <th>Created</th>
              <th style={{ minWidth: "320px" }}>Assign to Sales Rep</th>
            </tr>
          </thead>
          <tbody>
            {visible.length === 0 && (
              <tr><td colSpan={9} style={{ textAlign: "center", padding: "24px", color: "#666" }}>No dealers match your search.</td></tr>
            )}
            {visible.map(d => (
              <tr key={d.id}>
                <td><input type="checkbox" checked={!!this.state.selectedIds[d.id]} onChange={() => this.toggleSelect(d.id)} /></td>
                <td>{d.name}</td>
                <td>{d.email}</td>
                <td>{d.company}</td>
                <td>{d.industryType}</td>
                <td>{d.fficZips}</td>
                <td>{d.fairfieldAccountNumber}</td>
                <td>{d.createdAt}</td>
                <td>
                  <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                    <DropDownList
                      data={options}
                      textField="name"
                      dataItemKey="email"
                      value={this.state.perRowTarget[d.id] || null}
                      onChange={(e) => this.setState({ perRowTarget: { ...this.state.perRowTarget, [d.id]: e.target.value } })}
                      defaultItem={{ email: "", name: "Choose..." }}
                      style={{ flex: 1 }}
                    />
                    <button
                      className="ui-button"
                      onClick={() => this.reassignOne(d.id)}
                      disabled={this.state.busy}
                    >
                      Assign
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
